const ResortTable = ({ data, location }) => {
  const RESORTS = {
    'Animal Kingdom Kidani Village': 'wdw',
    'Animal Kingdom Jambo House': 'wdw',
    'Aulani': 'other',
    'Bay Lake Tower': 'wdw',
    'Beach Club Villas': 'wdw',
    'BoardWalk Villas': 'wdw',
    'Boulder Ridge': 'wdw',
    'Copper Creek': 'wdw',
    'Grand Californian': 'other',
    'Grand Floridian': 'wdw',
    'Hilton Head Island': 'other',
    'Old Key West': 'wdw',
    'Polynesian': 'wdw',
    'Riviera Resort': 'wdw',
    'Saratoga Springs': 'wdw',
    'Vero Beach': 'other'
  }
  
  const ROOMTYPES = {
    'Inn Room': 0,
    'Hotel Room': 0.5,
    'Tower Studio': 1,
    'Studio': 2,
    'Studio with Walk In Shower': 3,
    '1 Bedroom': 4,
    '2 Bedroom': 5,
    '2 Bedroom Lock Off': 6,
    '2 Bedroom Lock Off with Walk In Shower': 7,
    '3 Bedroom': 8,
    '3 Bedroom Cottage': 9,
    'Cabin': 10,
    'Treehouse': 11,
    'Grand Villa': 12,
    'Bungalow': 13
  }

  const VIEWTYPES = {
    'Value': 0,
    'Standard': 1,
    'Near Hospitality': 2,
    'Preferred': 3,
    'Savanna': 4,
    'Kilimanjaro Club': 5,
    'Lake': 6,
    'Theme Park': 7,
    'Island Gardens': 8,
    'Poolside Gardens': 9,
    'Ocean': 10,
    'Garden/Pool': 11,
    'Boardwalk': 12,
  }

  if (data && RESORTS[data.resort] === location) {
    data.viewTypes = [];
    data.roomTypes = [];
    data.listings.forEach(listing => {
      data.viewTypes.push(listing.view);
      data.roomTypes.push(listing.roomType);
    });
  
    data.viewTypes = [...new Set(data.viewTypes)].sort((a, b) => VIEWTYPES[a] - VIEWTYPES[b]);
    data.roomTypes = [...new Set(data.roomTypes)].sort((a, b) => ROOMTYPES[a] - ROOMTYPES[b])
    
    return (
      <>
        <table class="resort-table">
          <tr>
            <th colSpan={data?.roomTypes.length + 1}>{data.resort}</th>
          </tr>
          <tr>
            <th></th>
            {data.roomTypes.map(roomType => (<th className="room-type">{roomType}</th>))}
          </tr>
  
          {data.viewTypes.map((viewType) => (
            <tr>
              <td className="view-type">{viewType}</td>
              {data.roomTypes.map(roomType => {
                const x = data.listings?.find(listing => listing.roomType === roomType && listing.view === viewType);
                const y = x?.points;
                return<td className="point-cell">{y}</td>
              })}
            </tr>))}
        </table>
      </>
    )
  } else return (<div></div>)
}

export default ResortTable
